import React from 'react';
export const Calendar = React.lazy(() => import('./Calendar.jsx'));